import React from "react";
import Routes from "./routes";

import "antd/dist/antd.css";
import "./global.css";

import { Provider } from "react-redux";
import Store from "./store";

const App = () => (
  <Provider store={Store}>
    <Routes />
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js